﻿namespace WebPortal.Hub.Default {
    export class DefaultHub extends BaseHub {
        constructor() {
            super();
            this.iniDefaultHub();
        }

        public iniDefaultHub() {
            let SessionRequest: string;

            this.HubObj.client.PrepareSearchField = (_SearchFieldData: any) => {
                // console.info(JSON.stringify(_SearchFieldData));
                Default_CustomerSearch_Handler.PrepareSearchFieldArea(_SearchFieldData);
            };
            this.HubObj.client.PrepareCustomerData = (_CustomerData: any) => {
                // console.info(JSON.stringify(_CustomerData));
                Default_CustomerSearch_Handler.PrepareCustomerArea(_CustomerData);
            };

            this.HubObj.client.PrepareBookmarkData = (_BookmarkData: any) => {
                Default_Bookmark_Handler.PrepareBookmarkArea(_BookmarkData);
            };

            this.HubObj.client.PrepareHistoryData = (_HistoryData: any) => {
                Default_History_Handler.PrepareHistoryArea(_HistoryData);
            };

            this.HubObj.client.PrepareFAQData = (_FAQData: any) => {
                Default_FAQ_Handler.PrepareFAQArea(_FAQData);
            };

            this.HubObj.client.PrepareChangeLogData = (_ChangeLogData: any) => {
                Default_ChangeLog_Handler.PrepareChangeLogArea(_ChangeLogData);
            };

            this.HubObj.client.PrepareConfMgmtInitializationURLData = (_ConfMgmtInitializationURLData: any) => {
                (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).PrepareConfMgmtInitializationURLModal(_ConfMgmtInitializationURLData);
                (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).CheckSpoAndShowModal($("#hdf_se_request_param").val());
                //setTimeout(() => {
                //    Close_Status_Message();
                //    $("#pn_modal_confmgmtinitializationurls").modal({ backdrop: 'static', keyboard: false })
                //}, 1000);
            };

            this.HubObj.client.SetRequestCodeForNewSession = (_SessionRequest: string) => {
                SessionRequest = _SessionRequest;
            }

            this.HubObj.client.StartNewSession = () => {
                Close_Status_Message();
                if (!!SessionRequest) {
                    setTimeout(() => {
                        WebPortal.openWindow(window.location.protocol + "//" + window.location.host + "/session.aspx?se_request=" + SessionRequest);
                    }, 500);
                } else {
                    Show_Status_Message_Cause("Open new Session", "Parameter Error on Open new Session", true);
                }
            }

            this.HubObj.client.FinalizeNewSession = () => {
                console.error("Error on Initialize new Session (Finalize Session)");
                if (!!SessionRequest) {
                    WebPortalHubObj.server.doFinalizeBackend(SessionRequest, ActualWebsite);
                    SessionRequest = null;
                }
            }
        }

        protected onInitializedBackend(): void {
            super.onInitializedBackend();
            if (!LoginRequired) {
                if (FirstHubConnecting) {
                    FirstHubConnecting = false;
                    let requestParam = $("#hdf_se_request_param").val();
                    if (!!requestParam) {
                        console.info("Default - HubConnected");
                        console.info("Default - Read Default-Data");
                        let userSettings = $("#hdf_settings").val();
                        if (!!userSettings) {
                            let userSettingsObj = JSON.parse(userSettings);
                            switch (userSettingsObj.InitializationTab_ID as number) {
                                case 1:
                                    $("#nav_customer_search").click();
                                    break;
                                case 2:
                                    $("#nav_bookmark").click();
                                    break;
                                case 3:
                                    $("#nav_history").click();
                                    break;
                                default:
                                    $("#nav_customer_search").click();
                                    break;
                            }
                        }
                    } else {
                        console.error("Default - Error, no Request String found!");
                    }
                }
            }
        }
    }
}